import dayjs from "dayjs";
import React from "react";
import { IRecord } from "../../interfaces/record";
import { getRecordsCase } from "../../services/record.service";
import { useError } from "../../store/ErrorModal";

export default function useHistoryRecordPage() {
  const [initialDate, setInitialDate] = React.useState<Date>(
    new Date("2021-09-25")
  );
  const [finaleDate, setFinaleDate] = React.useState<Date>(new Date());
  const [searchKey, setSearchKey] = React.useState<string>("");
  const [record, setRecord] = React.useState<IRecord[]>([]);
  const [dataForShow, setDataForShow] = React.useState<IRecord[]>([]);
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const { onError } = useError();
  const fetchData = React.useCallback(async () => {
    setIsLoading(true);
    try {
      const recordData = await getRecordsCase();
      const recordDataItem = recordData.data.filter((item: IRecord) => {
        if (!item.type || item.type === "product") return false;
        return true;
      });
      setRecord(recordDataItem);
    } catch (error) {
      setIsLoading(false);
      onError(error as any);
    }
    setIsLoading(false);
  }, [onError]);

  React.useEffect(() => {
    fetchData();
  }, [fetchData]);

  React.useEffect(() => {
    if (!record || record.length === 0) return;

    const formatDate = (date: string | number | Date) =>
      new Date(dayjs(date).format("YYYY-MM-DD"));

    const dateData = record.filter((item) => {
      if (
        formatDate(item.timeStamp) < formatDate(initialDate || new Date()) ||
        formatDate(item.timeStamp) > formatDate(finaleDate || new Date())
      )
        return false;
      return true;
    });

    const tagString = (tags: string[]) => {
      let tag = "";
      tags.forEach((item) => {
        tag += item;
      });
      return tag;
    };

    const nData = dateData.filter((item) => {
      if (!item.firstName || !item.lastName || !item.displayName) return false;

      item.summary = item.summary || "";
      item.product.productName = item.product.productName || "";
      const tags = item.tags || [];
      return (
        item.firstName.includes(searchKey) ||
        item.lastName.includes(searchKey) ||
        item.displayName.includes(searchKey) ||
        item.product.productName.includes(searchKey) ||
        tagString(tags).includes(searchKey) ||
        item.summary.includes(searchKey)
      );
    });

    nData.sort(
      (a, b) =>
        new Date(b.timeStamp).getTime() - new Date(a.timeStamp).getTime()
    );
    setDataForShow(nData);
  }, [searchKey, setSearchKey, initialDate, finaleDate, record]);
  return {
    setSearchKey,
    dataForShow,
    isLoading,
    setInitialDate,
    setFinaleDate,
  };
}
